/* CorbinLink Kit Type behavior (CHR: CorbinLink PDP)
   - Gates the CorbinLink card when the selected light has no CorbinLink variant
     (the gate is the absence of the variant; this only mirrors the catalog).
   - Updates per-card prices from the variant map on light changes.
   - Quiets the Doors option when CorbinLink is selected (door-agnostic RF kits).
   - Unlock button switches the light to the unlocking value and selects CorbinLink.
*/
(function () {
  'use strict';

  function init(root) {
    var kitType = root.querySelector('[data-ccw-kit-type]');
    if (!kitType || kitType.dataset.ccwInit) return;
    kitType.dataset.ccwInit = '1';

    var picker = kitType.closest('variant-picker');
    if (!picker) return;

    var clLights = (kitType.dataset.clLights || '').split('||').filter(Boolean);
    var lightOptionName = kitType.dataset.lightOptionName;
    var unlockLight = kitType.dataset.unlockLight;
    var clCard = kitType.querySelector('[data-ccw-kit-card="cl"]');
    var clInput = clCard && clCard.querySelector('input[type="radio"]');
    var unlockEl = kitType.querySelector('[data-ccw-unlock]');
    var unlockBtn = kitType.querySelector('[data-ccw-unlock-btn]');
    var variantMap = [];
    try {
      variantMap = JSON.parse(kitType.querySelector('[data-ccw-variant-map]').textContent);
    } catch (e) { /* map is an enhancement, not a requirement */ }

    var lightField = picker.querySelector('[data-option-name="' + CSS.escape(lightOptionName) + '"]');
    var doorsField = picker.querySelector('[data-option-name="Doors"]');
    var doorsOption = doorsField && doorsField.closest('.m-product-option');
    var doorsNote = null;
    var DOOR_AGNOSTIC = '2 & 4-Door';

    function doorRadio(val) {
      if (!doorsField) return null;
      var radios = doorsField.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) if (radios[i].value === val) return radios[i];
      return null;
    }

    function currentDoor() {
      if (!doorsField) return null;
      var checked = doorsField.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var select = doorsField.querySelector('select');
      return select ? select.value : null;
    }

    function selectDoor(val) {
      var input = doorRadio(val);
      if (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      var select = doorsField && doorsField.querySelector('select');
      if (select && select.value !== val) {
        select.value = val;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function firstRealDoor() {
      if (!doorsField) return null;
      var radios = doorsField.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) if (radios[i].value !== DOOR_AGNOSTIC) return radios[i].value;
      var select = doorsField.querySelector('select');
      if (select) for (var j = 0; j < select.options.length; j++) if (select.options[j].value && select.options[j].value !== DOOR_AGNOSTIC) return select.options[j].value;
      return null;
    }

    /* The door-agnostic value exists only so the wireless variant has a Doors
       value; it is never a customer choice, so hide it from the Doors UI. */
    (function hideAgnosticDoor() {
      var input = doorRadio(DOOR_AGNOSTIC);
      if (input) {
        var wrap = input.closest('label') || input.parentElement;
        if (wrap) wrap.style.display = 'none';
      }
      var select = doorsField && doorsField.querySelector('select');
      if (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === DOOR_AGNOSTIC) select.options[i].hidden = true;
        }
      }
    })();

    function selectedLight() {
      var checked = lightField && lightField.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      var select = lightField && lightField.querySelector('select');
      return select ? select.value : null;
    }

    function selectedKitType() {
      var checked = kitType.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney && window.MinimogSettings) {
        return Shopify.formatMoney(cents, MinimogSettings.money_format);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function priceFor(kitValue, lightValue) {
      for (var i = 0; i < variantMap.length; i++) {
        var v = variantMap[i];
        if (v.options.indexOf(kitValue) !== -1 && v.options.indexOf(lightValue) !== -1) {
          return v.price;
        }
      }
      return null;
    }

    function ensureDoorsNote() {
      if (doorsNote || !doorsOption) return;
      doorsNote = document.createElement('div');
      doorsNote.className = 'ccw-doors-note';
      doorsNote.textContent = 'One CorbinLink\u2122 Wireless kit fits 2-door and 4-door. No cab harness to length-match.';
      doorsNote.hidden = true;
      doorsOption.appendChild(doorsNote);
    }

    function lightToken(v) {
      if (!v) return '';
      v = v.toLowerCase();
      if (v.indexOf('ghost') !== -1) return 'ghost';
      if (v.indexOf('headlight') !== -1) return 'headlights';
      if (v.indexOf('bumper') !== -1) return 'bumper';
      if (v.indexOf('fang') !== -1) return 'fang';
      if (v.indexOf('temp') !== -1) return 'temp';
      if (v.indexOf('round') !== -1 || v.indexOf('3/4') !== -1) return 'round';
      return v;
    }

    function syncLightShowcase(light) {
      var cards = document.querySelectorAll('[data-ccw-light-card]');
      if (cards.length < 2) return;
      var grid = cards[0].closest('.front-light-options__grid');
      if (!grid) return;
      var token = lightToken(light);
      var matched = false;
      cards.forEach(function (c) {
        if (lightToken(c.getAttribute('data-ccw-light-card')) === token) matched = true;
      });
      var mention = grid.parentElement.querySelector('[data-ccw-light-mention]');
      if (!matched) {
        grid.classList.remove('ccw-filtered');
        cards.forEach(function (c) { c.classList.remove('ccw-hidden', 'ccw-hero'); });
        if (mention) mention.hidden = true;
        return;
      }
      grid.classList.add('ccw-filtered');
      var others = [];
      cards.forEach(function (c) {
        var isSel = lightToken(c.getAttribute('data-ccw-light-card')) === token;
        c.classList.toggle('ccw-hidden', !isSel);
        c.classList.toggle('ccw-hero', isSel);
        if (!isSel) {
          var t = c.querySelector('.front-light-options__title');
          others.push(t ? t.textContent.trim() : c.getAttribute('data-ccw-light-card'));
        }
      });
      if (!mention) {
        mention = document.createElement('div');
        mention.className = 'ccw-light-mention';
        mention.setAttribute('data-ccw-light-mention', '');
        var label = document.createElement('span');
        label.className = 'ccw-light-mention__label';
        mention.appendChild(label);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ccw-light-mention__btn';
        btn.textContent = 'Change your front light selection';
        btn.addEventListener('click', function () {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          picker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
        mention.appendChild(btn);
        grid.parentElement.insertBefore(mention, grid.nextSibling);
      }
      mention.hidden = false;
      mention.querySelector('.ccw-light-mention__label').textContent = 'Also available: ' + others.join(', ') + '.';
    }

    function syncLightMentions(light) {
      var picks = document.querySelectorAll('[data-ccw-light-pick]');
      if (!picks.length) return;
      var token = lightToken(light);
      var matched = false;
      picks.forEach(function (pick) {
        var isMatch = lightToken(pick.getAttribute('data-ccw-light-pick')) === token;
        pick.hidden = !isMatch;
        if (isMatch) matched = true;
      });
      document.querySelectorAll('.ccw-light-fallback').forEach(function (fallback) {
        fallback.hidden = matched;
      });
    }

    function sync() {
      var light = selectedLight();
      syncLightShowcase(light);
      syncLightMentions(light);
      var gated = clLights.indexOf(light) === -1;

      if (clCard) {
        clCard.classList.toggle('is-gated', gated);
        if (clInput) clInput.disabled = gated;
        if (unlockEl) unlockEl.hidden = !gated;

        if (gated && selectedKitType() && selectedKitType().indexOf('CorbinLink') !== -1) {
          var wiredInput = kitType.querySelector('[data-ccw-kit-card="wired"] input[type="radio"]');
          if (wiredInput && !wiredInput.checked) {
            wiredInput.checked = true;
            wiredInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      var clPriceEl = kitType.querySelector('[data-ccw-cl-price]');
      var wiredPriceEl = kitType.querySelector('[data-ccw-wired-price]');
      var clPrice = priceFor('CorbinLink Wireless', light);
      var wiredPrice = priceFor('Wired', light);
      if (clPriceEl && clPrice !== null) clPriceEl.textContent = formatMoney(clPrice);
      if (wiredPriceEl && wiredPrice !== null) wiredPriceEl.textContent = formatMoney(wiredPrice);

      ensureDoorsNote();
      var isCl = (selectedKitType() || '').indexOf('CorbinLink') !== -1;

      /* Single door-agnostic wireless variant: entering CorbinLink switches the
         hidden Doors value to it; leaving restores a real door choice. Guarded
         by value equality so the change events cannot loop. */
      if (doorsField) {
        var door = currentDoor();
        if (isCl && door !== DOOR_AGNOSTIC && (doorRadio(DOOR_AGNOSTIC) || (doorsField.querySelector('select option[value="2 & 4-Door"]')))) {
          selectDoor(DOOR_AGNOSTIC);
        } else if (!isCl && door === DOOR_AGNOSTIC) {
          var real = firstRealDoor();
          if (real) selectDoor(real);
        }
      }
      document.body.classList.toggle('ccw-cl-selected', isCl);
      var jump = kitType.parentElement.querySelector('[data-ccw-cl-jump]') || picker.querySelector('[data-ccw-cl-jump]');
      if (jump) jump.hidden = !isCl || !document.getElementById('ccw-corbinlink-feature');
      if (doorsOption) {
        doorsOption.classList.toggle('ccw-doors-hidden', isCl);
        if (doorsNote) doorsNote.hidden = !isCl;
      }
    }

    if (unlockBtn) {
      unlockBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var lightInput = lightField && lightField.querySelector('input[type="radio"][value="' + CSS.escape(unlockLight) + '"]');
        if (!lightInput) {
          var lightSelect = lightField && lightField.querySelector('select');
          if (lightSelect) {
            lightSelect.value = unlockLight;
            lightSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (!lightInput.checked) {
          lightInput.checked = true;
          lightInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        window.setTimeout(function () {
          if (clInput && !clInput.disabled && !clInput.checked) {
            clInput.checked = true;
            clInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          sync();
        }, 0);
      });
    }

    var jumpLink = picker.querySelector('[data-ccw-cl-jump]');
    if (jumpLink) {
      jumpLink.addEventListener('click', function (e) {
        var target = document.getElementById('ccw-corbinlink-feature');
        if (!target) return;
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }

    var whichBtn = picker.querySelector('[data-ccw-which-toggle]');
    var compare = picker.querySelector('[data-ccw-compare]');
    if (whichBtn && compare) {
      whichBtn.addEventListener('click', function () {
        var open = compare.classList.toggle('is-open');
        whichBtn.setAttribute('aria-expanded', open);
      });
    }

    picker.addEventListener('change', function () {
      window.setTimeout(sync, 0);
    });
    document.addEventListener('variant:changed', function () {
      window.setTimeout(sync, 0);
    });

    sync();

    /* Deep link: ?kit=corbinlink (or ?kit=wireless) preselects CorbinLink.
       If the current light gates it, switch to the unlocking light first. */
    try {
      var kitParam = (new URLSearchParams(window.location.search).get('kit') || '').toLowerCase();
      if (kitParam === 'corbinlink' || kitParam === 'wireless') {
        if (clInput && clInput.disabled && unlockLight && lightField) {
          var unlockInput = lightField.querySelector('input[type="radio"][value="' + CSS.escape(unlockLight) + '"]');
          if (unlockInput && !unlockInput.checked) {
            unlockInput.checked = true;
            unlockInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        window.setTimeout(function () {
          if (clInput && !clInput.disabled && !clInput.checked) {
            clInput.checked = true;
            clInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          sync();
        }, 50);
      }
    } catch (e) { /* deep link is an enhancement */ }
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
